angular
    .module('app')
    .directive('smsMacros', function(){
        return {
            restrict: 'E',
            require: 'ngModel',
	      	scope: {
		        layout: '=',
		        header: '=',
		        remove: '='
	      	},
            link: function(scope, element, attrs, ngModel) {
		       	scope.macroses = 	[
							       		{ id: 'user_name', 			title: 'Customer name'},
							       		{ id: 'user_birthday', 		title: 'Birthday'},
							       		{ id: 'bonuses_amount', 	title: 'Bonuses amount'},
							       		{ id: 'first_trans_days', 	title: 'Days from first transaction'},
							       		{ id: 'last_trans_days', 	title: 'Days from last transaction'},
							       	];

            	if (scope.remove && scope.remove.length>0)
            		for (var i in scope.remove)
            			for (var k in scope.macroses)
            				if (scope.macroses[k].id === scope.remove[i])
            					scope.macroses.splice(k, 1);

		       	scope.onAddMacros = function (id) {
		       		var v = ngModel.$modelValue;

		       		if (v)
		       			ngModel.$setViewValue(v + ' {{' + id + '}}');
		       		else
		       			ngModel.$setViewValue('{{' + id + '}}');
		       	}
            },
	        template:   '<div class="small message-macros-snippet">'+
	        				'<div class="margin-bottom-5"' + 
	        					 'ng-if="header">' +
	        							'<span translate> TEXT_ADD_TO_MESSAGE </span>:' + 
	        				'</div>' +
	        				'<a href class="btn btn-xs green margin-bottom-5"' +
	        					'ng-class="{\'btn-block\':layout==\'vertical\'}"' +
    							'ng-repeat="m in macroses"' +
    							'ng-click="onAddMacros(m.id)"' + 
    							'translate>' + 
	        						'{{m.title}}'+
	        				'</a>' + 
	        			'</div>'
        };
    })